export default __webpack_public_path__ + "static/media/cake-4.c55cc742.jpg";